import Ajax from "Utils/ajax";
export const getSuggestionList = (data) => Ajax.post('setting/getSuggestionList',data);
export const getSuggestionStatus = (data) => Ajax.post('setting/getSuggestionStatus',data);
export const getSuggestionCategory = (data) => Ajax.post('setting/getSuggestionCategory',data);
export const getSuggestionDepartment = (data) => Ajax.post('setting/getSuggestionDepartment',data);
export const getSuggestion = (data) => Ajax.post('setting/getSuggestion',data);
export const addUpdateSuggestion = (data) => Ajax.post('setting/addUpdateSuggestion',data);
export const deleteSuggestion = (data) => Ajax.post('setting/deleteSuggestion',data);